<template lang="html">
  <div ref="modelSubmissions">
    <div class="flex justify-center items-center">
      <p class="b f3">Model Submissions</p>
      <pl-button
        @click.native="show_info = true"
        class="pl-icon"
        style="margin-right: -36px;"
      >
        <i class="fas fa-info-circle" />
      </pl-button>
    </div>
    <div class="center">
      <div v-for="submission in model_submissions">
        <submission-card
          v-if="
            !submission.is_hidden ||
            (submission.is_hidden && hasTeacherPermissionsInCourse) ||
            ownSubmission(submission.id)
          "
          :key="submission.id"
          :submission="submission"
          :isInSummary="true"
          class="model-submission-card center tl"
        />
      </div>
      <div
        v-if="
          !model_submissions.length ||
          (!hasTeacherPermissionsInCourse &&
            model_submissions.length &&
            isLastHidden)
        "
        class="flex justify-center items-center"
      >
        <div class="w-50 br2">
          <div class="flex items-center justify-between mb3">
            <div class="bg-light-gray h2 br2 mv1 w-80 mr2" />
            <i class="fa-2x fa fa-star light-gray" aria-hidden="true" />
          </div>
          <div class="bg-light-gray h1 br2 mv2" />
          <div class="bg-light-gray h1 br2 mv2" />
          <div class="bg-light-gray h1 br2 mv2" />
        </div>
        <div class="flex-grow ml4 tl pl-subheading gray">
          <p>
            Teachers use the submission "star" to identify model submissions
            from the RoundTable discussion.
          </p>
          <p>
            All model submissions will appear here in the RoundTable summary.
          </p>
        </div>
      </div>
      <pl-dialog
        v-if="show_info"
        @close="show_info = false"
        class="pl-subheading italics"
      >
        <p>
          Teachers use the submission "star" to identify model submissions from
          the RoundTable discussion.
        </p>
        <p>All model submissions will appear here in the RoundTable summary.</p>
        <pl-button @click.native="show_info = false" class="pl-primary">
          OK
        </pl-button>
      </pl-dialog>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import SubmissionCard from '../submissionCard/submissionCard.vue';

  export default {
    data() {
      return {
        show_info: false,
      };
    },
    props: {
      scrollToElement: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      SubmissionCard,
    },
    computed: {
      ...mapGetters([
        'getProfile',
        'hasTeacherPermissionsInCourse',
        'getOrderedSubmissions',
      ]),
      model_submissions() {
        return (
          this.getOrderedSubmissions.filter(
            (s) => s.is_model_response && s.is_started
          ) || []
        );
      },
      isLastHidden() {
        var count = 0;
        this.model_submissions.forEach((submission) => {
          if (submission.is_hidden) {
            count += 1;
          }
        });


        if (count === this.model_submissions.length) {
          return true;
        }

        return false;
      },
    },
    methods: {
      goToSubmission(event) {
        return this.$emit('goToSubmission', { submissionID: event });
      },
      ownSubmission(id) {
        return this.getProfile.my_rt_user_details.submission_id === id;
      },
    },
    mounted() {
      if (this.scrollToElement) {
        this.$refs.modelSubmissions.scrollIntoView({
          behavior: 'smooth',
        });
      }
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';
  .model-submission-card
    border-radius: 1em;
    max-width: 650px;
    margin-bottom: 2em;
</style>



// WEBPACK FOOTER //
// roundtableSummaryModelSubmissions.vue?118f3f0e